import React, { useState, useEffect } from 'react';
import twinseyeLogo from '../images/TwinSeye-Logo-Text.png';
import backgroundImage from "../images/Twinseye-Background.png";
import textAreaBackground from "../images/UsernamePassBackground.png"
import { useParams } from 'react-router-dom';
import { getText } from '../languageutil/translations';
import { getLanguageBasedImage } from '../languageutil/ImageUtil';
import styles from './IntroPages.module.css';

function EnterCompanyNamePage({ navigate }) {
  const { status } = useParams();
  const [companyName, setCompanyName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [continueButtonImage, setContinueButtonImage] = useState(null);
  const [saveButtonImage, setSaveButtonImage] = useState(null);

  useEffect(() => {
    setContinueButtonImage(getLanguageBasedImage('DevamEtButton.png'));
    setSaveButtonImage(getLanguageBasedImage('KaydetButton.png'));
  }, []);

  const handleFindCompany = async () => {
    try {
      if (!companyName.trim()) {
        setErrorMessage('Şirket adı boş olamaz.');
        return;
      }

      const simplifiedName = companyName.trim().toLowerCase();

      const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/companies/find?companyName=${encodeURIComponent(simplifiedName)}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('jwt'),
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.company) {
          localStorage.setItem("companyName", simplifiedName);
          navigate('/intro');
        } else {
          setErrorMessage('Şirket bulunamadı.');
        }
      } else {
        setErrorMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      console.error('Error finding company:', error);
      setErrorMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  const handleCreateCompany = async () => {
    try {
      if (!companyName.trim()) {
        setErrorMessage('Şirket adı boş olamaz.');
        return;
      }

      const simplifiedName = companyName.trim().toLowerCase();

      const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/companies/create`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('jwt'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ companyName: simplifiedName }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        if (data.company) {
          localStorage.setItem("companyName", simplifiedName);
          navigate('/intro');
        } else {
          setErrorMessage('Şirket oluşturulamadı.');
        }
      } else {
        const errorData = await response.json();
        setErrorMessage(errorData.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      console.error('Error creating company:', error);
      setErrorMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  const handleSubmit = () => {
    if (status === 'saved') {
      handleFindCompany();
    } else if (status === 'new') {
      handleCreateCompany();
    }
  };

  return (
    <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "Arimo", flexDirection: "column" }}>
      <div className={styles.content} style={{}}>
        <div style={{ position: "absolute", top: "0vh", left: "0vw", height: "20vh", width: "100vw", backgroundColor: "white" }} />
        <img src={twinseyeLogo} alt="CoreXFuture" style={{ position: "absolute", top: "3vh", left: "4vw", height: "14vh", alignSelf: "center" }} />
        <div className={styles.leftside} style={{ paddingTop: "5vh" }}>
          <textarea
            type="text"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            required
            style={{
              backgroundImage: `url(${textAreaBackground})`,
              backgroundColor: "transparent",
              width: "70%",
              minWidth: "300px",
              backgroundSize: "100% 100%",
              border: "0px solid",
              padding: "10px",
              fontSize: "35px",
              resize: "none",
              backgroundPosition: "center",
              marginBottom: "20px",
              color: "white",
              textAlign: "center",
              aspectRatio: 6,
              alignContent: "center",
              fontFamily: "Arimo"
            }}
            placeholder={getText('companyNamePlaceholder')}
          />
          {errorMessage && (
            <div style={{ color: 'red', marginTop: '10px', fontSize: '18px', fontFamily: "Arimo" }}>
              {errorMessage}
            </div>
          )}
        </div>
        <div className={styles.rightside} style={{}}>
          <div className={styles.buttoncontainer} style={{}} >
            <img
              src={status === "saved" ? continueButtonImage : saveButtonImage}
              alt={status === "saved" ? getText('continueButton') : getText('saveButton')}
              className={styles.startbutton}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnterCompanyNamePage;